import { h } from 'preact'
import Icon from '../../assets'
import ButtonControl from '../../button-control'
import { Filters, FilterSelector } from '../index'

type Props = {
  areFiltersOpenFromFilterPill: boolean,
  selectedFilter: string | undefined,
  appliedFilters?: Filters,
  filters: Array<FilterSelector>,
  onFilterClick: (filterId: string) => void,
  onFilterBack: () => void,
  onApplyFilters: (id: string, data: any[]) => void,
  onCancelFilters: () => void,
  onLoad: (filterId: string, items: any[]) => void,
}

const FiltersMenu = ({ areFiltersOpenFromFilterPill, selectedFilter, appliedFilters, filters, onFilterClick, onFilterBack, onApplyFilters, onCancelFilters, onLoad } : Props) => {
  const match = filters.filter(filter => filter.id === selectedFilter)[0]

  if (match) {
    const { id, name, items, component, isSearchable, fetchUrl, isMain } = match
    let FilterSelectorComponent = component

    if (!FilterSelectorComponent) return null

    return <div>
      {areFiltersOpenFromFilterPill || isMain
        ? <div className='overview__filters-box-header'>{name}</div>
        : <div className='overview__filters-box-header-back' onClick={() => onFilterBack()}>
          <Icon width={20} height={20} icon='chevronLeft' />
          <div>{name}</div>
        </div>}
      <div>
        <FilterSelectorComponent
          id={id}
          name={name}
          items={items}
          isSearchable={isSearchable}
          selectedFilterItems={appliedFilters?.[id] || []}
          fetchUrl={fetchUrl}
          onLoad={onLoad}
        >
          {({ isApplyButtonDisabled, data }: { isApplyButtonDisabled: boolean, data: any }) =>
            <div>
              <hr />
              <div className='overview__filters-box-buttons'>
                <ButtonControl
                  newStyle
                  size='small'
                  variant='brand'
                  title='Apply'
                  disabled={isApplyButtonDisabled}
                  onClick={() => onApplyFilters(id, data)}
                />
                <ButtonControl
                  newStyle
                  size='small'
                  title='Cancel'
                  onClick={() => onCancelFilters()}
                />
              </div>
            </div>
          }
        </FilterSelectorComponent>
      </div>
    </div>
  }

  return <div>
    { filters
      .filter(filter => !filter.isMain)
      .map(filter => {
        if (filter.type === 'separator') return <hr class='separator' />
        return <div class={`overview__filters-box-filter qa-${filter.id}-selector`} key={filter.id} onClick={() => onFilterClick(filter.id)}>
          <span>{filter.name}</span>
        </div>
      }) }
  </div>
}

export default FiltersMenu
